import {Injectable} from '@angular/core';

import {Tenant} from '../_models/index';
import {LoginHelper} from '../helpers';

import {AuthenticationService} from './index';
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class TenantService {
  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  getAllInfo() {
    return this.http.get<any>(this.config.api + '/api/tenants/info');
  }

  tenantExists(tenantName: string) {
    return this.http.get<any>(this.config.api + '/api/tenants/exists/' + tenantName);
  }

  @Load()
  getAll() {

    if (LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/tenants/all');
  }

  getAllComplianceAreas() {

    if (LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/tenants/complianceAreas');
  }

  @Load()
  uploadControls(model: any) {

    if (LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.put(this.config.api + '/api/tenants/uploadControls', model);
  }

  getById(id: number) {

    if (LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/tenants/tenant/' + id);
  }

  getCurrent() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/tenants/current');
  }

  @Load()
  checkPassword(password: string) {

    return this.http.post<any>(this.config.api + '/api/tenants/checkPassword', {accessKey: password});
  }

  @Load()
  create(tenant: Tenant) {

    return this.http.post<any>(this.config.api + '/api/tenants/create', tenant);
  }

  @Load()
  update(tenant: Tenant) {

    if (LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/tenants/update/' + tenant.tenantId, tenant);
  }

  @Load()
  delete(id: number, totalErase: boolean) {

    if (LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/tenants/delete/' + id + '/' + totalErase);
  }

  @Load()
  enable(id: number) {

    if (LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/tenants/enable/' + id, {});
  }

  @Load()
  setCanCreateComplianceArea(id: number, value: boolean) {
    if (LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/tenants/' + id + '/canCreateArea/' + value, {});
  }

  @Load()
  setCanCreatePartnerProjects(id: number, value: boolean) {
    if (LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/tenants/' + id + '/canCreatePartnerProjects/' + value, {});
  }

  @Load()
  initializeTenant(id: number) {
    if (LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/tenants/' + id + '/initialize', {});
  }

  public getAwsCustomer(id: number, token: string) {
    return this.http.post<any>(this.config.api + '/api/tenants/' + id + '/getAwsCustomer', {token});
  }
  public getAwsEntitlements(id: number, data: any) {
    return this.http.post<any>(this.config.api + '/api/tenants/' + id + '/getAwsEntitlements', data);
  }
}
